export default {"src":"/_next/static/media/share.1aab38df.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};